import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass, withModifiers as _withModifiers, mergeProps as _mergeProps, unref as _unref, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce8acc2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-left px-3 pt-3" }
const _hoisted_2 = { class: "d-flex align-center flex-wrap ga-2 mb-2" }
const _hoisted_3 = { class: "text-subtitle-1 font-weight-bold flex-grow-1" }
const _hoisted_4 = {
  key: 1,
  class: "text-center text-medium-emphasis pa-4"
}
const _hoisted_5 = { class: "d-flex align-center ga-2" }
const _hoisted_6 = {
  key: 0,
  class: "text-caption text-medium-emphasis email"
}
const _hoisted_7 = { class: "text-body-2 text-medium-emphasis" }
const _hoisted_8 = { class: "d-flex align-center ga-2" }
const _hoisted_9 = { class: "text-body-2 flex-grow-1" }
const _hoisted_10 = {
  key: 0,
  class: "text-medium-emphasis text-no-wrap"
}

import { bandoLista, estadoLista } from "@/utils/estadoLista";
import { computed, ref } from "vue";
import {
  InscripcionTorneoCreadoDTO,
  TorneoGestionInfoDTO,
} from "@/interfaces/Torneo";
import { cambiarEjercitoElegidoAsync } from "@/services/InscripcionesService";
import { retirarJugadorLigaAsync } from "@/services/LigaService";
import {
  cambiarGrupoAsync,
  retirarJugadorCopaAsync,
} from "@/services/CopaService";
import { FORMATO_COPA, textosEvento } from "@/Constant/FormatoTorneo";
import { mensajeDelBack } from "@/utils/mensajeDelBack";
import ModalAddJugadorTorneo from "@/components/GestionTorneos/ModalAddJugadorTorneo.vue";
import PuntosExtra from "@/components/GestionTorneos/PuntosExtra.vue";
import InterruptorPago from "@/components/GestionTorneos/InterruptorPago.vue";
import ModalDetalleInscripcion from "@/components/GestionTorneos/ModalDetalleInscripcion.vue";
import ModalElegirEjercito from "@/components/Inscripcion/ModalElegirEjercito.vue";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalError from "@/components/Commons/ModalError.vue";

const RETIRADO = "RETIRADO";


export default /*#__PURE__*/_defineComponent({
  __name: 'TablaInscritosLiga',
  props: {
    torneo: {},
    ligaGenerada: { type: Boolean },
    ligaCerrada: { type: Boolean },
    numeroGrupos: {},
    enEliminatoria: { type: Boolean }
  },
  emits: ["actualizado"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const esCopa = computed(() => props.torneo.torneo.formatoTorneo === FORMATO_COPA);
const textos = computed(() => textosEvento(props.torneo.torneo.formatoTorneo));

const emit = __emit;

// Los retirados al final; en la copa, por grupos y los que aún no tienen grupo después
const inscripciones = computed(() =>
  [...props.torneo.inscripciones].sort(
    (a, b) =>
      Number(esRetirado(a)) - Number(esRetirado(b)) ||
      (props.numeroGrupos ? (a.grupo ?? 999) - (b.grupo ?? 999) : 0) ||
      (a.nick ?? "").localeCompare(b.nick ?? "")
  )
);

function gruposPara(inscripcion: InscripcionTorneoCreadoDTO) {
  return Array.from({ length: props.numeroGrupos ?? 0 }, (_, i) => i + 1).filter(
    g => g !== inscripcion.grupo
  );
}

async function moverAGrupo(inscripcion: InscripcionTorneoCreadoDTO, grupo: number) {
  isGuardando.value = true;
  try {
    await cambiarGrupoAsync(props.torneo.torneo.idTorneo, inscripcion.idInscripcion, grupo);
    inscripcion.grupo = grupo;
  } catch (error) {
    mensaje.value = mensajeDelBack(error, "No se ha podido cambiar de grupo.");
    showError.value = true;
  } finally {
    isGuardando.value = false;
  }
}
// Buscador y filtros: a quien le falta la lista (sin entregar o ilegal, que hay que cambiar) y los que no han pagado,
// sin contar a los retirados
const search = ref<string | null>("");
const filtro = ref<"todos" | "faltanListas" | "sinPagar">("todos");
const enJuego = computed(() => inscripciones.value.filter(i => !esRetirado(i)));
const faltanListas = computed(() =>
  enJuego.value.filter(i => !["ENTREGADA", "OK"].includes((i.estadoLista ?? "").toUpperCase()))
);
const sinPagar = computed(() => enJuego.value.filter(i => i.esPago !== "SI"));
const normalizar = (texto: string) =>
  texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
const visibles = computed(() => {
  const base =
    filtro.value === "faltanListas"
      ? faltanListas.value
      : filtro.value === "sinPagar"
        ? sinPagar.value
        : inscripciones.value;
  const texto = normalizar(search.value ?? "").trim();
  return texto ? base.filter(i => normalizar(i.nick ?? "").includes(texto)) : base;
});

const activos = computed(
  () => props.torneo.inscripciones.filter(i => !esRetirado(i)).length
);

const showAddJugador = ref(false);
const inscripcionDetalle = ref<InscripcionTorneoCreadoDTO | null>(null);
const showEjercito = ref(false);
const inscripcionEjercito = ref<InscripcionTorneoCreadoDTO | null>(null);
const showRetirar = ref(false);
const inscripcionRetirar = ref<InscripcionTorneoCreadoDTO | null>(null);
const isGuardando = ref(false);
const showSuccess = ref(false);
const showError = ref(false);
const mensaje = ref("");

function esRetirado(inscripcion: InscripcionTorneoCreadoDTO) {
  return inscripcion.estadoInscripcion === RETIRADO;
}

function verDetalle(inscripcion: InscripcionTorneoCreadoDTO) {
  inscripcionDetalle.value = inscripcion;
}

function actualizarCampo(payload: {
  field: keyof InscripcionTorneoCreadoDTO;
  value: unknown;
}) {
  if (inscripcionDetalle.value)
    Object.assign(inscripcionDetalle.value, { [payload.field]: payload.value });
}

function pedirEjercito(inscripcion: InscripcionTorneoCreadoDTO) {
  inscripcionEjercito.value = inscripcion;
  showEjercito.value = true;
}

async function cambiarEjercito(ejercito: string) {
  if (!inscripcionEjercito.value) return;
  isGuardando.value = true;
  try {
    await cambiarEjercitoElegidoAsync(
      inscripcionEjercito.value.idInscripcion,
      ejercito
    );
    inscripcionEjercito.value.ejercitoElegido = ejercito;
    mensaje.value = "Ejército cambiado.";
    showSuccess.value = true;
  } catch (error) {
    mensaje.value = mensajeDelBack(error, "No se ha podido cambiar el ejército.");
    showError.value = true;
  } finally {
    isGuardando.value = false;
  }
}

function pedirRetirar(inscripcion: InscripcionTorneoCreadoDTO) {
  inscripcionRetirar.value = inscripcion;
  showRetirar.value = true;
}

async function retirar() {
  showRetirar.value = false;
  if (!inscripcionRetirar.value) return;
  isGuardando.value = true;
  try {
    const retirar = esCopa.value ? retirarJugadorCopaAsync : retirarJugadorLigaAsync;
    await retirar(props.torneo.torneo.idTorneo, inscripcionRetirar.value.idInscripcion);
    mensaje.value = `${inscripcionRetirar.value.nick} se ha retirado ${textos.value.del}.`;
    showSuccess.value = true;
    emit("actualizado");
  } catch (error) {
    mensaje.value = mensajeDelBack(error, "No se ha podido retirar al jugador.");
    showError.value = true;
  } finally {
    isGuardando.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, { class: "mb-4" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, "Jugadores (" + _toDisplayString(activos.value) + ")", 1),
            (!_ctx.ligaGenerada)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  color: "primary",
                  variant: "tonal",
                  size: "small",
                  "prepend-icon": "mdi-account-plus",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showAddJugador.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Añadir jugador ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          (inscripciones.value.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_v_text_field, {
                  modelValue: search.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
                  density: "compact",
                  label: "Buscar jugador",
                  "prepend-inner-icon": "mdi-magnify",
                  clearable: "",
                  "hide-details": "",
                  class: "mb-2"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_chip_group, {
                  modelValue: filtro.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filtro).value = $event)),
                  mandatory: "",
                  column: "",
                  "selected-class": "text-primary",
                  class: "mb-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_chip, {
                      value: "todos",
                      size: "small",
                      filter: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Todos (" + _toDisplayString(inscripciones.value.length) + ")", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_chip, {
                      value: "faltanListas",
                      size: "small",
                      filter: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Faltan listas (" + _toDisplayString(faltanListas.value.length) + ")", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_chip, {
                      value: "sinPagar",
                      size: "small",
                      filter: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("No pagado (" + _toDisplayString(sinPagar.value.length) + ")", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (inscripciones.value.length === 0)
          ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
              default: _withCtx(() => [
                _createTextVNode("Aún no hay jugadores inscritos.")
              ]),
              _: 1
            }))
          : (visibles.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Nadie con estos filtros "))
            : (_openBlock(), _createBlock(_component_v_row, {
                key: 2,
                dense: "",
                class: "px-2 pb-2"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibles.value, (inscripcion) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      key: inscripcion.idInscripcion,
                      cols: "12",
                      sm: "6",
                      lg: "4"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                          variant: "outlined",
                          class: "pa-3 text-left tarjeta",
                          role: "button",
                          tabindex: "0",
                          onClick: ($event: any) => (verDetalle(inscripcion)),
                          onKeydown: _withKeys(($event: any) => (verDetalle(inscripcion)), ["enter"])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["text-body-1 font-weight-bold flex-grow-1 nick", { 'text-disabled': esRetirado(inscripcion) }])
                              }, _toDisplayString(inscripcion.nick), 3),
                              (esRetirado(inscripcion))
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 0,
                                    size: "x-small",
                                    color: "error",
                                    variant: "tonal"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Retirado ")
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(PuntosExtra, {
                                    key: 1,
                                    inscripcion: inscripcion
                                  }, null, 8, ["inscripcion"])),
                              _createVNode(_component_v_menu, null, {
                                activator: _withCtx(({ props: menuProps }) => [
                                  _createVNode(_component_v_btn, _mergeProps({
                                    icon: "mdi-dots-vertical",
                                    variant: "text",
                                    size: "small",
                                    density: "comfortable",
                                    "aria-label": "Más acciones"
                                  }, menuProps, {
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                                  }), null, 16)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, { density: "compact" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item, {
                                        "prepend-icon": "mdi-eye",
                                        title: "Ver inscripción",
                                        onClick: ($event: any) => (verDetalle(inscripcion))
                                      }, null, 8, ["onClick"]),
                                      (inscripcion.email)
                                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: 0,
                                            "prepend-icon": "mdi-email-outline",
                                            title: "Escribir correo",
                                            href: `mailto:${inscripcion.email}`
                                          }, null, 8, ["href"]))
                                        : _createCommentVNode("", true),
                                      (!_ctx.ligaGenerada)
                                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: 1,
                                            "prepend-icon": "mdi-shield-edit",
                                            title: "Cambiar ejército",
                                            onClick: ($event: any) => (pedirEjercito(inscripcion))
                                          }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.numeroGrupos && !_ctx.ligaGenerada && !esRetirado(inscripcion))
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(gruposPara(inscripcion), (g) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: g,
                                              "prepend-icon": "mdi-account-switch",
                                              title: `Al grupo ${g}`,
                                              onClick: ($event: any) => (moverAGrupo(inscripcion, g))
                                            }, null, 8, ["title", "onClick"]))
                                          }), 128))
                                        : _createCommentVNode("", true),
                                      (_ctx.ligaGenerada && !_ctx.ligaCerrada && !esRetirado(inscripcion))
                                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: 3,
                                            "prepend-icon": "mdi-account-remove",
                                            "base-color": "error",
                                            title: `Retirar ${textos.value.del}`,
                                            onClick: ($event: any) => (pedirRetirar(inscripcion))
                                          }, null, 8, ["title", "onClick"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            (inscripcion.email)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(inscripcion.email), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_7, [
                              _createTextVNode(_toDisplayString(inscripcion.ejercitoElegido ?? "Sin ejército elegido") + " ", 1),
                              (_ctx.numeroGrupos)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" · " + _toDisplayString(inscripcion.grupo ? `Grupo ${inscripcion.grupo}` : "Sin grupo"), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(`text-${_unref(estadoLista)(inscripcion.estadoLista).color}`)
                                }, _toDisplayString(_unref(estadoLista)(inscripcion.estadoLista).texto), 3),
                                (_unref(bandoLista)(inscripcion.bando))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, " · " + _toDisplayString(_unref(bandoLista)(inscripcion.bando)!.texto), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode(InterruptorPago, {
                                esPago: inscripcion.esPago,
                                idInscripcion: inscripcion.idInscripcion,
                                onCambiado: esPago => (inscripcion.esPago = esPago)
                              }, null, 8, ["esPago", "idInscripcion", "onCambiado"])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onClick", "onKeydown"])), [
                          [_directive_ripple]
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
      ]),
      _: 1
    }),
    (showAddJugador.value)
      ? (_openBlock(), _createBlock(ModalAddJugadorTorneo, {
          key: 0,
          isVisible: showAddJugador.value,
          torneo: _ctx.torneo,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (showAddJugador.value = false)),
          onConfirm: _cache[5] || (_cache[5] = ($event: any) => (emit('actualizado')))
        }, null, 8, ["isVisible", "torneo"]))
      : _createCommentVNode("", true),
    (inscripcionDetalle.value)
      ? (_openBlock(), _createBlock(ModalDetalleInscripcion, {
          key: 1,
          inscripcion: inscripcionDetalle.value,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (inscripcionDetalle.value = null)),
          onUpdateInscripcion: actualizarCampo,
          onEliminarInscripcion: _cache[7] || (_cache[7] = ($event: any) => (emit('actualizado')))
        }, null, 8, ["inscripcion"]))
      : _createCommentVNode("", true),
    _createVNode(ModalElegirEjercito, {
      isVisible: showEjercito.value,
      titulo: `Ejército en ${textos.value.el}`,
      texto: `El jugador lleva este ejército en todas sus partidas ${textos.value.del}. Se puede cambiar hasta que se generen las jornadas.`,
      ejercitoActual: inscripcionEjercito.value?.ejercitoElegido,
      "onUpdate:isVisible": _cache[8] || (_cache[8] = ($event: any) => (showEjercito.value = $event)),
      onConfirm: cambiarEjercito
    }, null, 8, ["isVisible", "titulo", "texto", "ejercitoActual"]),
    _createVNode(_component_v_dialog, {
      modelValue: showRetirar.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showRetirar).value = $event)),
      "max-width": "420"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-wrap" }, {
              default: _withCtx(() => [
                _createTextVNode(" ¿Retirar a " + _toDisplayString(inscripcionRetirar.value?.nick) + " " + _toDisplayString(textos.value.del) + "? ", 1)
              ]),
              _: 1
            }),
            (_ctx.enEliminatoria)
              ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(" En su cruce pendiente pasa el rival. Lo que ya ha jugado sigue contando. Esta acción no se puede deshacer. ")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Se borran todas sus partidas, también las ya jugadas, y no cuentan ni en la clasificación ni en el ELO. Esta acción no se puede deshacer. ")
                  ]),
                  _: 1
                })),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "grey",
                  variant: "text",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (showRetirar.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancelar ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "tonal",
                  onClick: retirar
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Retirar")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGuardando.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((isGuardando).value = $event)),
      persistent: "",
      width: "200"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-6 d-flex justify-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "60"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccess.value,
      message: mensaje.value,
      "onUpdate:isVisible": _cache[12] || (_cache[12] = ($event: any) => (showSuccess.value = $event))
    }, null, 8, ["isVisible", "message"]),
    _createVNode(ModalError, {
      isVisible: showError.value,
      message: mensaje.value,
      "onUpdate:isVisible": _cache[13] || (_cache[13] = ($event: any) => (showError.value = $event))
    }, null, 8, ["isVisible", "message"])
  ], 64))
}
}

})